import { render } from "./edit-store.vue?vue&type=template&id=04c618c0&scoped=true"
import script from "./edit-store.vue?vue&type=script&lang=js"
export * from "./edit-store.vue?vue&type=script&lang=js"

import "./edit-store.vue?vue&type=style&index=0&id=04c618c0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c618c0"]])

export default __exports__